<div class="modal-header">
  <h4 class="modal-title">Ajout d'équipements</h4>
</div>

<div class="modal-body">
  <div class="form-horizontal" style="margin-top: 10px;">
    <form [formGroup]="formGroup">

      <div class="form-group">
        <label class="col-sm-2 control-label">
          Modèle <i class="required">*</i>
        </label>
        <div class="col-sm-4">
          <app-input-list-field formControlName="model_name"
                                class="wcm-highlight-req"
                                [ngClass]="{'wcm-highlight-error': formGroup.controls.model_name.errors }"
                                [list]="modelOptions"
                                (ngModelChange)="getConstructor($event)">
          </app-input-list-field>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-2 control-label">
          Constructeur <i class="required">*</i>
        </label>
        <div class="col-sm-4">
          <app-input-list-field formControlName="constructor_name"
                                class="wcm-highlight-req"
                                [ngClass]="{'wcm-highlight-error': formGroup.controls.constructor_name.errors }"
                                [list]="constructorOptions"
                                (ngModelChange)="filterModels($event)">
          </app-input-list-field>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-2 control-label">
          Quantité <i class="required">*</i>
        </label>
        <div class="col-sm-4">
          <input class="form-control wcm-highlight-req"
                 [ngClass]="{'wcm-highlight-error': formGroup.controls.quantity.errors }"
                 formControlName="quantity"
                 type="number"
                 [step]="1"
                 [min]="1" />
        </div>
      </div>

    </form>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-primary"
          [disabled]="formGroup.invalid"
          (click)="confirm()">
    Valider
  </button>

  <button class="btn btn-default" (click)="dismiss()">
    Annuler
  </button>
</div>
